import { PlayApiProvider } from '@mogzo/play';
import { BrowserRouter, Route, Routes } from 'react-router';
import { PageSpinner } from './components/ui';
import { webPlayApi } from './lib/play-api';
import { SessionProvider, useSession } from './lib/session';
import { Account } from './pages/Account';
import { CompleteProfile } from './pages/CompleteProfile';
import { Join } from './pages/community/Join';
import { PlayPage } from './pages/community/PlayPage';
import { PostPage } from './pages/community/PostPage';
import { TeamCommunity, TestCommunity } from './pages/community/TestCommunity';
import { Discover } from './pages/Discover';
import { AnswerDeveloperQuestion } from './pages/developers/AnswerQuestion';
import { DeveloperApply } from './pages/developers/Apply';
import { DeveloperApplySent } from './pages/developers/ApplySent';
import { ConfirmDeveloperApplication } from './pages/developers/ConfirmApplication';
import { EditProfile } from './pages/EditProfile';
import { Feed } from './pages/Feed';
import { ForgotPassword } from './pages/ForgotPassword';
import { LiveGamePage } from './pages/games/LiveGame';
import { LivePlayPage } from './pages/games/LivePlay';
import { Home } from './pages/Home';
import { DeveloperTerms } from './pages/legal/DeveloperTerms';
import { Privacy } from './pages/legal/Privacy';
import { Terms } from './pages/legal/Terms';
import { MatchInvite } from './pages/MatchInvite';
import { Messages } from './pages/Messages';
import { NotFound } from './pages/NotFound';
import { Notifications, StopEmails } from './pages/Notifications';
import { ResetPassword } from './pages/ResetPassword';
import { Search } from './pages/Search';
import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';
import { TwoFactorChallenge } from './pages/TwoFactorChallenge';
import { VerifyEmail } from './pages/VerifyEmail';

/** mogzo.com's home: the feed for whoever sees the public side, the coming-soon page for the rest. */
function HomeRoute() {
  const { publicSide } = useSession();
  if (publicSide === undefined) return <PageSpinner />;
  return publicSide ? <Feed /> : <Home />;
}

export function AppRoutes() {
  return (
    <PlayApiProvider api={webPlayApi}>
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-in/two-factor" element={<TwoFactorChallenge />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/account" element={<Account />} />
        <Route path="/account/edit" element={<EditProfile />} />
        <Route path="/account/:section" element={<Account />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/test/:slug" element={<TestCommunity />} />
        <Route path="/test/:slug/play" element={<PlayPage />} />
        <Route path="/test/:slug/posts/:postId" element={<PostPage />} />
        <Route path="/team/:slug" element={<TeamCommunity />} />
        <Route path="/team/:slug/posts/:postId" element={<PostPage kind="team" />} />
        <Route path="/search" element={<Search />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/requests" element={<Messages />} />
        <Route path="/messages/new" element={<Messages />} />
        <Route path="/messages/:id" element={<Messages />} />
        <Route path="/notifications/stop" element={<StopEmails />} />
        <Route path="/games/:slug" element={<LiveGamePage />} />
        <Route path="/games/:slug/play" element={<LivePlayPage />} />
        <Route path="/games/:slug/posts/:postId" element={<PostPage kind="game" />} />
        <Route path="/join/:code" element={<Join />} />
        <Route path="/match/:code" element={<MatchInvite />} />
        <Route path="/developer-terms" element={<DeveloperTerms />} />
        <Route path="/developers/apply" element={<DeveloperApply />} />
        <Route path="/developers/apply/sent" element={<DeveloperApplySent />} />
        <Route path="/developers/apply/confirm" element={<ConfirmDeveloperApplication />} />
        <Route path="/developers/answer" element={<AnswerDeveloperQuestion />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PlayApiProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <AppRoutes />
      </SessionProvider>
    </BrowserRouter>
  );
}
